import { BenefitPageState } from '../@types/benefitPageState';
import { BenefitsListPage } from '../@types/benefitsListPage';

export const getBenefitPageState = ({
  isLoading,
  benefitsListPage,
  isKaeuferPlusError,
  isMieterPlusError,
  isWohnenPlusError,
}: {
  isLoading: boolean;
  benefitsListPage: BenefitsListPage;
  isKaeuferPlusError?: boolean;
  isMieterPlusError?: boolean;
  isWohnenPlusError?: boolean;
}) => {
  const errorStateMapping = {
    [BenefitsListPage.KauferPlus]: isKaeuferPlusError,
    [BenefitsListPage.MieterPlus]: isMieterPlusError,
    [BenefitsListPage.WohnenPlus]: isWohnenPlusError,
  };

  if (isLoading) return BenefitPageState.LOADING;
  if (errorStateMapping[benefitsListPage]) return BenefitPageState.ERROR;
  return BenefitPageState.CONTENT;
};
